import { StatusBadge } from '../ui/StatusBadge';
import { ReportStatus, ReportStatusLabels } from '../../types/reports';
import type { StatusVariant } from '../../theme/colors';

const variantMap: Record<string, StatusVariant> = {
  [ReportStatus.DRAFT]: 'entwurf',
  [ReportStatus.IN_PROGRESS]: 'inBearbeitung',
  [ReportStatus.SUBMITTED]: 'eingereicht',
  [ReportStatus.APPROVED]: 'freigegeben',
  [ReportStatus.REVISION_NEEDED]: 'revision',
};

interface ReportStatusBadgeProps {
  status: string | undefined | null;
}

export function ReportStatusBadge({ status }: ReportStatusBadgeProps) {
  const variant = status ? variantMap[status] : undefined;
  if (!variant) return null;
  return <StatusBadge status={variant} label={ReportStatusLabels[status as ReportStatus]} />;
}
